import { render, staticRenderFns } from "./SignatureSettingsModal.vue?vue&type=template&id=5da26010&scoped=true"
import script from "./SignatureSettingsModal.vue?vue&type=script&lang=js"
export * from "./SignatureSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./SignatureSettingsModal.vue?vue&type=style&index=0&id=5da26010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da26010",
  null
  
)

export default component.exports